// src/i18n/index.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../locales/en/common.json';
import rwCommon from '../locales/rw/common.json';

const resources = {
    en: {
        common: enCommon,
    },
    rw: {
        common: rwCommon,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'rw', // Kinyarwanda as default
        lng: 'rw', // Set Kinyarwanda as initial language
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false,
        },

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },

        defaultNS: 'common',
        ns: ['common'],
    });

export default i18n;